import { EXPORT_EXCEPTIONS } from "components/Person/TimeTracking/TimeTrackingConstants";

export const filterFictitiousProjects = (trackedDays) => {
    return trackedDays.filter(trackedDay => !EXPORT_EXCEPTIONS.includes(trackedDay.project?._id))
};
